// Time-of-day buckets for every surface that tints by the hour: the web
// workspace's living background, the Brief's ambient glow, and the Mac/iOS
// TimeOfDaySky (cadence-kit). Boundaries are browser-local hours and must
// stay identical across surfaces; each surface picks its own colours.
export type TimeOfDayBucket = 'dawn' | 'morning' | 'midday' | 'afternoon' | 'evening';

// First hour of each bucket, in day order. Dawn runs from midnight.
const BUCKET_STARTS: ReadonlyArray<readonly [number, TimeOfDayBucket]> = [
  [0, 'dawn'],
  [8, 'morning'],
  [12, 'midday'],
  [16, 'afternoon'],
  [19, 'evening'],
];

export function timeOfDayBucket(date: Date): TimeOfDayBucket {
  const hour = date.getHours();
  let bucket: TimeOfDayBucket = 'dawn';
  for (const [start, name] of BUCKET_STARTS) {
    if (hour >= start) bucket = name;
  }
  return bucket;
}

// Milliseconds until the next bucket starts (midnight after evening), so a
// caller can schedule one timeout per bucket instead of polling.
export function msUntilNextBucket(date: Date): number {
  const hour = date.getHours();
  const nextStart = BUCKET_STARTS.find(([start]) => start > hour)?.[0] ?? 24;
  const next = new Date(date);
  next.setHours(nextStart, 0, 0, 0); // 24 rolls over to tomorrow's midnight
  return next.getTime() - date.getTime();
}
